import React from 'react'
import { BulbFilled, BulbOutlined } from '@ant-design/icons'

import { LntIconButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import type { TableRowHighlightButtonProps } from './types'

export const TableRowHighlightButton: React.FC<TableRowHighlightButtonProps> = ({ active, ...iconButtonProps }) => {
  const icon = active ? <BulbFilled /> : <BulbOutlined />

  return (
    <LntIconButton
      { ...iconButtonProps }
      type={ BUTTON_TYPE.text }
      size={ SIZE.small }
      icon={ icon }
    />
  )
}
